import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { usePortfolio } from '../context/PortfolioContext';
import PortfolioCard from '../components/portfolio/PortfolioCard';

const Portfolio = () => {
  const { projects } = usePortfolio();
  const [selectedCategory, setSelectedCategory] = useState<string>('All');
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const uniqueCategories = ['All', ...new Set(projects.map(project => project.category))];
    setCategories(uniqueCategories);
  }, [projects]);

  const filteredProjects = selectedCategory === 'All'
    ? projects
    : projects.filter(project => project.category === selectedCategory);

  return (
    <div className="content-panel">
      {/* Header */}
      <section className="py-8 md:py-12">
        <h1 className="font-display text-fluid-3xl mb-4">Portfolio</h1>
        <p className="text-fluid-lg text-foreground/70 max-w-2xl">
          Explore a selection of my personal projects and experiments in web development, AI, and more.
        </p>
      </section>

      {/* Filters */}
      <section className="py-4">
        <div className="flex flex-wrap gap-2">
          {categories.map((category) => (
            <button
              key={category}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                selectedCategory === category
                  ? 'bg-primary text-white'
                  : 'bg-card border border-foreground/10 text-foreground/70 hover:text-foreground hover:border-foreground/20'
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-8">
        {filteredProjects.length > 0 ? (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
            {filteredProjects.map((project) => (
              <Link key={project.id} to={`/portfolio/${project.slug}`} className="block h-full">
                <PortfolioCard project={project} clickable />
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-foreground/70 text-lg">No projects found in this category.</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default Portfolio;
